import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProgressBarService } from 'src/@order/components/progress-bar/progress-bar.service';
import { AuthServiceLocal } from 'src/@order/services/auth.service';

@Component({
  selector: 'app-add-business-name-dialog',
  templateUrl: './add-business-name-dialog.component.html',
  styleUrls: ['./add-business-name-dialog.component.scss']
})
export class AddBusinessNameDialogComponent implements OnInit {
  heading: string;
  sectorList: [] = []

  form: FormGroup;
  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    public _matDialogRef: MatDialogRef<AddBusinessNameDialogComponent>,
    private _auth: AuthServiceLocal,
    private _progressBar: ProgressBarService,
    private _messageBar: MatSnackBar,
    private _fb: FormBuilder
  ) {

    this.sectorList = this._data.sectorList;
    this.heading = this._data.heading;
    // console.log(" this.sectorList",  this.sectorList);

    this.createForm()

  }

  ngOnInit(): void {
  }

  createForm() {
    this.form = this._fb.group({
      busniessName: ['', Validators.required],
      busniessSector: ['', Validators.required]
    })
  }

  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
    } else {
      this.form.markAsPending();
      const params = {
        businessName: this.form.get('busniessName').value,
        sectorName: this.form.get('busniessSector').value,
      }
      // console.log("params", params);
      this._progressBar.show();
      this._auth.onSavePdasBussinessName(params).subscribe((res: any) => {
        if (res.response == 1) {
          this._progressBar.hide();
          this._messageBar.open(res.message, 'OKAY', { duration: 2000 });
          localStorage.setItem('authUser', JSON.stringify(res.data.user));
          this._matDialogRef.close(true);
        } else {
          this._progressBar.hide();
          this._messageBar.open(res.message, 'OKAY', { duration: 4000 })
        }
      })
    }
  }
}
